import { TOAuthSource } from '@/utils/oAuth';
import { fetch } from '@/utils/request';
import request from './request';

export function getUser() {
  return request<UserResp>({
    method: 'GET',
    url: '/user',
  });
}
export function updatePass(data: UserPasswordReq) {
  return request<UserResp>({
    method: 'PUT',
    url: '/user/password',
    data,
  });
}
export function updateUsername(data: { password: string; username: string }) {
  return request({
    method: 'PUT',
    url: '/user/username',
    data,
  });
}
export function updateProfile(data: any) {
  return request<UserResp>({
    method: 'PUT',
    url: '/user',
    data,
  });
}
export function forgetPass(data: any) {
  return request<any>({
    method: 'post',
    url: '/user/forget_password',
    data,
  });
}

export function resetPass(data: any) {
  return request<any>({
    method: 'put',
    url: `/user/reset_password`,
    data,
  });
}

export function getUserAuth() {
  return request<{
    page: string[];
    teamUser: {
      [key: string]: string[];
    };
    user: string[];
  }>({
    method: 'get',
    url: '/user/all/permissions',
    cache: true,
  });
}

export function getAllInterestingList() {
  return request<Obj<string>>({
    method: 'get',
    url: '/user/all/interesting',
  });
}
interface ChangePwdReq {
  password: string;
}
export function putChangePwd(data: ChangePwdReq) {
  return request<any>({
    method: 'put',
    url: `/user/forcePassword`,
    data,
  });
}

export function getMFAStatus() {
  return request<'INACTIVE' | 'ACTIVE'>({
    method: 'get',
    url: '/user/mfa/status',
  });
}

export function putCreateMFASecretKey() {
  return request<string>({
    method: 'put',
    url: `/user/mfa/secretKey`,
  });
}

export async function getMFASecretKeyQrCode() {
  const response = await fetch<Blob>({
    method: 'get',
    url: `/api/usercenter/user/mfa/secretKeyQrCode`,
    responseType: 'blob',
  });

  const url = URL.createObjectURL(response.data);

  return url;
}

export function putMFAStatus(status: 'ACTIVE' | 'INACTIVE', mfaCode?: string) {
  return request<boolean>({
    method: 'put',
    url: `/user/mfa/status`,
    params: {
      status,
      mfaCode,
    },
  });
}

export function getOAuthList() {
  return request<{ uid: string; oauthSource: TOAuthSource }[]>({
    method: 'get',
    url: '/user/oauth/list',
  });
}

export function getRenderOAuth(source: TOAuthSource) {
  return request<string>({
    method: 'get',
    url: `/user/oauth/render/${source}`,
  });
}

export function putUnlinkOAuth(source: TOAuthSource) {
  return request({
    method: 'put',
    url: `/user/oauth/del/${source}`,
  });
}

export function postFingerprint(data: { info: string }) {
  return request({
    method: 'post',
    url: `/user/fingerprint`,
    data,
  });
}
